export const navigationLinks = [
  {
    name: "About",
    link: "/#about",
  },
  {
    name: "Features",
    link: "/#features",
  },
  {
    name: "Vimon Showcase",
    link: "/#showcase",
  },
  {
    name: "Roadmap",
    link: "/#roadmap",
  },
  {
    name: "Community",
    link: "/#community",
  },
];

// News
// Game Jams
// Find an Agency
// Become a Partner
// Success Stories
export const newsLinks = [
  {
    name: "Game Jams",
    link: "/#game-jams",
  },
  {
    name: "Find an Agency",
    link: "/#find-an-agency",
  },
  {
    name: "Become a Partner",
    link: "/#become-a-partner",
  },
  {
    name: "Success Stories",
    link: "/#success-stories",
  },
];

// FAQ
// Help Center
// Terms of use
// Privacy Policy
export const supportLinks = [
  {
    name: "FAQ",
    link: "/#faq",
  },
  {
    name: "Help Center",
    link: "/#help-center",
  },
  {
    name: "Terms of use",
    link: "/#terms-of-use",
  },
  {
    name: "Privacy Policy",
    link: "/#privacy-policy",
  },
];

// Service Status
// Changelog
// Whitepaper
// Careers
// Press

export const companyLinks = [
  {
    name: "Service Status",
    link: "/#service-status",
  },
  {
    name: "Changelog",
    link: "/#changelog",
  },
  {
    name: "Whitepaper",
    link: "/#whitepaper",
  },
  {
    name: "Careers",
    link: "/#careers",
  },
  {
    name: "Press",
    link: "/#press",
  },
];
